// Submits the parent form on Enter, allows Shift+Enter for newlines
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    this.element.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event) {
    if (event.key !== 'Enter' || event.shiftKey || event.repeat) return

    event.preventDefault()
    this.element.closest('form').requestSubmit()
  }
}
